<template>
  <div class="Home wrap">
    <div class="left-side">
      <article class="text">
        <h1>Galvanic/Voltaic Cells</h1>
        <p>
          Select different metals and aqueous solutions to build a galvanic/volatic cell that generates electrical energy. Observe the corresponding oxidation and reduction half reactions.
        </p>
        <router-link to="/Experiment" class="btn arrow">Start</router-link>
        <p class="credit">Special thanks to <span>Tom Greenbowe</span> and <span>John Gelder</span></p>
      </article>
    </div>

    <div class="right-side">
      <img src="home_beaker.png" alt="Beakers" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.Home {
  display: grid;
  grid-template-columns: 1fr;
  min-height: 100vh;
  padding-top: 100px;

  @media screen and (min-width: 767px) {
    grid-template-columns: 1fr 1fr;
    padding-top: 0%;
  }
  @media screen and (min-width: 1000px) {
    grid-template-columns: 2fr 3fr;
  }
}

.left-side {
  display: grid;
  place-items: center;
  position: relative;
  padding-bottom: 3rem;

  @media screen and (min-width: 767px) {
    place-items: center start;
  }

  .text {
    width: 100%;
    padding: var(--pad2);
    display: grid;

    @media screen and (min-width: calc(1440px + 2rem)) {
      padding-left: 0%;
    }

    p {
      font-size: 1.25rem;
      line-height: 2.25rem;
      width: 85%;
    }

    .btn {
      margin-top: 10vh;
      justify-self: flex-end;
    }
  }

  h1 {
    font-weight: 900;
    font-size: 2.5rem;
    margin-bottom: 1rem;
    width: 85%;

    @media screen and (min-width: 1110px) {
      font-size: 3.75rem;
    }
  }

  p.credit {
    margin: 0;
    font-size: 1rem;
    line-height: 1.1rem;
    position: absolute;
    bottom: 2rem;
    left: 2rem;
    span { white-space: nowrap; }
  }

}

.right-side {
  background: var(--bg2);
  position: relative;
  display: grid;
  place-items: center;

  &:after {
    display: none;
    @media screen and (min-width: 1440px) {
      display: block;
      content: "";
      position: absolute;
      top: 0%;
      right: calc(((100vw - 1440px) / 2) * -1);
      width: calc((100vw - 1440px) / 2);
      height: 100%;
      background: var(--bg2);
    }
  }
}
</style>
